export default "__VITE_PUBLIC_ASSET__08f00eb5__"